// src/pages/Admin/TableauDeBordAdherents/data/adminAdherentsSections.js

import {
  FaChartLine,
  FaUsersCog,
  FaVenusMars,
  FaTable,
  FaMapMarkedAlt,
  FaUserClock,
  FaClipboardCheck,
} from "react-icons/fa";

export const ADMIN_ADHERENTS_SECTIONS = [
  {
    key: "derniersInscrits",
    id: "section-derniers-inscrits",
    eyebrow: "Inscriptions",
    title: "Derniers adhérents inscrits",
    shortTitle: "Derniers",
    description:
      "Liste compacte des dernières fiches adhérents créées dans le club.",
    icon: FaUserClock,
    defaultOpen: true,
  },
  {
    key: "visites",
    id: "section-visites",
    eyebrow: "Visites",
    title: "Évolution des visites",
    shortTitle: "Visites",
    description:
      "Suivez les visites par jour, filtrez par période, activez le lissage et nettoyez les anciennes données si nécessaire.",
    icon: FaChartLine,
    defaultOpen: true,
  },
  {
    key: "statuts",
    id: "section-statuts",
    eyebrow: "Dossiers",
    title: "Répartition des statuts d'inscription",
    shortTitle: "Statuts",
    description:
      "Analyse des adhérents selon leur statut d’inscription pour la saison active.",
    icon: FaClipboardCheck,
    defaultOpen: true,
  },
  {
    key: "cours",
    id: "section-cours",
    eyebrow: "Répartition",
    title: "Répartition des adhérents par cours",
    shortTitle: "Cours",
    description:
      "Graphique des adhérents répartis par groupes, cours ou créneaux.",
    icon: FaUsersCog,
    defaultOpen: false,
  },
  {
    key: "communes",
    id: "section-communes",
    eyebrow: "Géographie",
    title: "Répartition par commune",
    shortTitle: "Communes",
    description:
      "Visualisation des communes représentées par les adhérents de la saison active.",
    icon: FaMapMarkedAlt,
    defaultOpen: false,
  },
  {
    key: "statsDetaillees",
    id: "section-stats-detaillees",
    eyebrow: "Tableau",
    title: "Statistiques communes, sexe et âge",
    shortTitle: "Tableau",
    description: "Tableau prêt à copier pour vos dossiers de subvention.",
    icon: FaTable,
    defaultOpen: false,
  },
  {
    key: "genreAge",
    id: "section-genre-age",
    eyebrow: "Profil adhérents",
    title: "Répartition genre & âge",
    shortTitle: "Genre / âge",
    description: "Analyse globale des adhérents par genre, mineurs et majeurs.",
    icon: FaVenusMars,
    defaultOpen: false,
  },
];

export function buildDefaultOpenSections() {
  return ADMIN_ADHERENTS_SECTIONS.reduce((acc, section) => {
    acc[section.key] = section.defaultOpen;
    return acc;
  }, {});
}